<template>
    <div>
        <el-dialog
        class="BidDialog"
        :title="title"
        :visible.sync="flag"
        width="640px"
        :close-on-click-modal="false"
        @close="btnEvent"
        height="600px">
            <div v-if="reasonRow.dailyStatus !== '5' && reasonRow.dailyStatus !== '6' && reasonRow.dailyStatus !== '7'">
                <el-form ref="dglog">
                    <el-form-item prop="examineReason" class="tab-width">
                        <el-input disabled="true" type="textarea" :rows="5" v-model="modelform.examineReason" placeholder="在此输入复核原因"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="tab-box">
                <el-table :data="moduleFileInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="fileName" label="附件名称" width="200" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <div>
                                <span>
                                    <el-button size="mini" type="text" @click="actionFn(scope.row, '1')">预览</el-button>
                                </span>
                                <span class="span-button">
                                    <el-button size="mini" type="text" @click="actionFn(scope.row, '2')">下载</el-button>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="tab-box">
                <div class="title m-top-t">操作历史记录</div>
                <el-table :data="performanceExamineDerates" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="derateStatusText" label="操作" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="createUserCode" label="操作人" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="操作时间" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="examineReason" label="意见" width="200" align="center">
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="btnEvent">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { filePreview } from '@/utils/filePreview.js';
import { mobileExamineDerates } from '../../../lsrm/api/achievements/daylyAssessment.js';
export default {
    props: {
        showFlag: {
            type: Boolean
        },
        title: {
            type: String
        },
        showFlagType: {
            type: Number
        },
        reasonRow: {
            type: Object,
            default() {
                return {};
            }
        },
        selectItem: {
            type: Array
        },
        dictData: {
            type: Object
        }
    },
    data() {
        return {
            performanceExamineDerates: [],
            flag: false,
            moduleFileInfo: [],
            modelform: {
                examineReason: '',
                rejectDirection: ''
            }
        };
    },
    methods: {
        btnEvent() {
            this.flag = false;
            this.$emit('closeDay', false);
        },
        actionFn(row, type, index) {
            if (type === '2') {
                window.open(row.fileUrl, '_parent');
            } else if (type === '1') {
                filePreview(row);
            } else {
                this.moduleFileInfo.splice(index, 1);
            }
        },
        conversionData(list) {
            list.forEach(el => {
                el.derateStatusText = this.dictData.SRM_PERFOR_OPERATE_TYPE[el.derateStatus];
                el.examineReason = el.examineType === '1' ? el.examineReason : el.derateStatus === '0' ? el.examineReason : el.rejectDirection;
            });
        }
    },
    watch: {
        showFlag(val) {
            this.flag = val;
            mobileExamineDerates({ derateCode: this.reasonRow.derateCode }).then(res => {
                if (res && +res.code === 0) {
                    this.modelform.examineReason = res.data.examineReason;
                    this.modelform.rejectDirection = res.data.rejectDirection;
                    this.moduleFileInfo = res.data.moduleFile;
                    this.performanceExamineDerates = res.data.performanceExamineDerates;
                    this.conversionData(this.performanceExamineDerates);
                }
            });
        }
    }
};
</script>

<style lang="less">
.BidDialog {
    .number {
        color: #00BCBF;
        cursor: pointer;
    }
    .BidDialog-tip {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
    .info {
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .el-table__row {
        font-size: 12px;
    }
    .upload-enclosure {
        width:100%;
        display: flex;
        justify-content: space-between;
        margin: 10px 0
    }
    .title {
        font-size: 14px;
    }
    .upload_enclosure_top {
        color: #00BCBF;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .el-dialog__footer {
        border-top: 1px solid #eee;
    }
    .m-t10 {
        margin-top: 10px;
    }
    .tab-box {
        margin-top:10px;width: 100%;
    }
    .span-button {
        margin-left: 10px;
    }
    .m-top-t {
        margin: 20px 0 10px;
    }
}
</style>